/**
 * Maps a level name to the data-field name that holds that level's identifier in
 * MDL responses (e.g. "campaign" → "campaignName"). The BE owns the authoritative
 * mapping per service+level in `SERVICE_CONFIGURATIONS.primaryDimensions`; this
 * file mirrors the common convention so the FE doesn't need a round-trip to know
 * the field name for a freshly-selected level.
 *
 * Known exceptions that don't follow the camelCase + "Name" rule:
 *  - SEO `page` → `page`
 *  - Reputation `site` → `site`
 *  - BrightEdge `keyword` → `KeywordName` (PascalCase first letter)
 */
const EXCEPTIONS: Record<string, string> = {
    page: "page",
    site: "site",
    keyword: "KeywordName",
};

export function levelToDimensionField(levelName: string): string {
    const key = levelName.toLowerCase();
    if (key in EXCEPTIONS) return EXCEPTIONS[key];
    const camel = key.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
    return `${camel}Name`;
}

/** Backend field name for the campaign dimension. Campaign filtering is front-end-only (see WidgetFactory). */
export const CAMPAIGN_DIMENSION_METRIC = "campaignName";
